import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from "vue";
import { useRoute } from "vue-router";
import "@/assets/styles/main.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
watch(() => route.meta.title, (title) => { document.title = `${title || "Start"} · Freiraum GaLaBau`; }, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})